// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import 'bootstrap';
import 'flatpickr';
import 'flatpickr/dist/flatpickr.css';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js'; 
require("flatpickr/dist/flatpickr.css")

require("jquery")

Rails.start()
Turbolinks.start()
ActiveStorage.start()

document.addEventListener('turbolinks:load', () => {
  flatpickr('.datepicker', {
    altInput: true,
    altFormat: 'd/m/Y',
    dateFormat: 'Y-m-d',
    locale: Portuguese
  });

  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
    new bootstrap.Tooltip(el);
  });
});

require("packs/anticipation")
require("packs/cpf_somente_numeros")
require("packs/folder_number")
require("packs/unlock-password")
require("packs/pagination")
require("packs/toggleIcon")
require("packs/another-requirement-validation")
require("packs/atest-validation")
require("packs/datapicker_validation")
require("packs/timer")
